// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "body {\n  font-family: \"Roboto\";\n  font-weight: 500;\n  margin: 0;\n  box-sizing: content-box;\n}\n\n::-webkit-scrollbar {\n  display: none;\n}\n\n.fade-enter {\n  opacity: 0;\n}\n.fade-enter-active {\n  opacity: 1;\n  transition: opacity 300ms;\n}\n.fade-exit {\n  opacity: 1;\n}\n.fade-exit-active {\n  opacity: 0;\n  transition: opacity 300ms;\n}\n", ""]);
// Exports
module.exports = exports;
